<p-dialog
  [(visible)]="visible"
  [resizable]="false"
  [header]="ctitle"
  [style]="{ width: '800px', height: '600px' }"
  [contentStyle]="{ height: 'calc(600px - 110px)', overflow: 'hidden' }"
  styleClass="easDialog"
>
  <div class="easDialogBody">

    <div *ngIf="nodata" class="noData">
      <h3>Ni podatkov!</h3>
    </div>

    <div class="topRow">
      <p-selectButton
        class="typeSwitch"
        [options]="seltypes"
        [(ngModel)]="seltype"
        (onChange)="chGraphType($event)"
      ></p-selectButton>

      <div *ngIf="hasTimeFilter()" class="dateRow">
        <p-datepicker
          class="easCal"
          [(ngModel)]="sDate"
          [showIcon]="true"
          dateFormat="dd.mm.yy"
          (change)="selectFromDate($event)"
          (onSelect)="selectFromDate($event)"
        ></p-datepicker>

        <span class="dateSep">–</span>

        <p-datepicker
          class="easCal"
          [(ngModel)]="eDate"
          [showIcon]="true"
          dateFormat="dd.mm.yy"
          (change)="selectToDate($event)"
          (onSelect)="selectToDate($event)"
        ></p-datepicker>
      </div>
    </div>

    <div class="chartWrap">
      <p-chart #chart [data]="cdata" (onDataSelect)="selectData($event)"></p-chart>
    </div>

    <div class="dialogFooter">
      <button class="easBtn" type="button" pButton (click)="exportCsv()">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>CSV</span>
      </button>
    </div>

  </div>
</p-dialog>
